import React from "react";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import {
  restrictToFirstScrollableAncestor,
  restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import SoftBox from "components/SoftBox";

export const dragHandleColumn = { name: " ", align: "center", width: "48px" };

export const verticalSortModifiers = [
  restrictToVerticalAxis,
  restrictToFirstScrollableAncestor,
];

export const sortAutoScroll = {
  layoutShiftCompensation: false,
  threshold: {
    x: 0,
    y: 0.18,
  },
};

export const dropAnimation = null;

export function useVerticalSortSensors() {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 6 },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
}

export function DragHandle({ attributes, listeners }) {
  return (
    <SoftBox
      {...attributes}
      {...listeners}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      sx={{
        cursor: listeners ? "grab" : "grabbing",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        touchAction: "none",
        color: "#737373",
      }}
    >
      <DragIndicatorIcon sx={{ width: "22px", height: "22px" }} />
    </SoftBox>
  );
}

export function FullRowOverlay({ children, width, height, backgroundColor }) {
  if (!children) {
    return null;
  }

  return (
    <table
      style={{
        width: width || "100%",
        height: height || "auto",
        minHeight: height || undefined,
        borderCollapse: "collapse",
        tableLayout: "auto",
        backgroundColor: backgroundColor || "white",
        boxShadow: "none",
        cursor: "grabbing",
        pointerEvents: "none",
      }}
    >
      <tbody>
        <tr style={{ height: height || "auto" }}>{children}</tr>
      </tbody>
    </table>
  );
}

export function reorderByIds(list, orderedIds, idKey) {
  const byId = new Map(list.map((item) => [String(item[idKey]), item]));
  return orderedIds.map((id) => byId.get(String(id))).filter(Boolean);
}
